import React from "react";
import { Card } from "antd";

const LeaveSummaryCard = ( props ) => {
  const { leaveType, leaveAmount, remainingLeave } = props;

  return (
    <Card className={`flex flex-col rounded-xl card-border-s ${leaveType.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex flex-col justify-start">
        <p className="text-xs">{leaveType} Days</p>
        <p className={`text-xl font-bold label-color ${leaveType.toLowerCase().replace(/\s+/g, "-")}`}>{leaveAmount}</p>
        <p className="text-xs">of {remainingLeave} remaining</p>
      </div>
    </Card>
  
  );
};
export default LeaveSummaryCard;